export default __webpack_public_path__ + "static/media/p3.830dc3a7.png";